import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, Trash2, Loader2, RefreshCw } from "lucide-react";
import { Label } from "@/components/ui/label";
import { uploadMedia, mediaUrl, apiError } from "../api";

export function ImageUpload({ value, onChange, kind = "general", label = "Bild", aspect = "aspect-video", testid = "image-upload", hint }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) { toast.error("Datei zu groß (max. 8 MB)"); return; }
    setBusy(true);
    try { const m = await uploadMedia(file, kind); onChange(m.id); toast.success("Bild hochgeladen"); }
    catch (err) { toast.error(apiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid={testid}>
      {label && <Label className="text-[11px] uppercase tracking-wide text-stone-500">{label}</Label>}
      <div className={`mt-1 relative rounded-xl overflow-hidden border border-dashed border-stone-300 bg-[#FAF7F2] ${aspect}`}>
        {value ? <img src={mediaUrl(value)} alt="" className="absolute inset-0 w-full h-full object-cover" data-testid={`${testid}-preview`} />
          : <button type="button" onClick={() => ref.current?.click()} className="absolute inset-0 flex flex-col items-center justify-center text-stone-400 hover:text-[#4A1D24] text-xs gap-2" data-testid={`${testid}-empty`}><ImagePlus className="h-6 w-6" />Bild auswählen</button>}
        {busy && <div className="absolute inset-0 bg-white/70 flex items-center justify-center"><Loader2 className="h-6 w-6 animate-spin text-[#4A1D24]" /></div>}
      </div>
      <div className="flex gap-2 mt-2">
        <button type="button" data-testid={`${testid}-button`} onClick={() => ref.current?.click()} disabled={busy} className="inline-flex items-center gap-1.5 text-xs font-semibold text-[#4A1D24] px-3 py-1.5 rounded-full border border-[#4A1D24]/30 hover:bg-[#4A1D24]/5">
          {value ? <RefreshCw className="h-3.5 w-3.5" /> : <ImagePlus className="h-3.5 w-3.5" />}{value ? "Ersetzen" : "Hochladen"}
        </button>
        {value && <button type="button" data-testid={`${testid}-remove`} onClick={() => onChange(null)} className="inline-flex items-center gap-1.5 text-xs font-semibold text-red-700 px-3 py-1.5 rounded-full border border-red-200 hover:bg-red-50"><Trash2 className="h-3.5 w-3.5" />Entfernen</button>}
      </div>
      {hint && <p className="text-[11px] text-stone-400 mt-1">{hint}</p>}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
    </div>
  );
}
